import { SortingDirection } from "@infragistics/igniteui-angular";

export class IOrderColumn {
    OrderBy : string;
    OrderDirection : SortingDirection;
}